import type { ProductDto } from "../../types/ProductDto";
import type { ProductEntity } from "../../types/ProductEntity";

export const ProductDtoToEntity = ({ ...rest }: Readonly<ProductDto>): ProductEntity => {
    return { ...rest };
};
